import { render, staticRenderFns } from "./installer-details.vue?vue&type=template&id=663c8cb8&"
import script from "./installer-details.vue?vue&type=script&lang=js&"
export * from "./installer-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports